<div class="outer-container">
  <app-current-path></app-current-path>
  <div class="console-container">
    <div class="name-container">
      <span>{{ title }}</span>
      <div class="btn-grp">
        <input class="main-btn" type="submit" value="Go Back" (click)="goBack()" />
        <input class="main-btn ms-2" type="submit" value="Save Changes" (click)="saveChanges()" />
      </div>
    </div>
    <div class="details">
      <div class="heading">
        <span class="sub-heading">GROUP DETAILS</span>

        <hr class="solid-divider" />
      </div>
      <div class="row crud-container">
        <div class="form-group group-detail-field">
          <label class="group-field-label" for="groupName">Name</label>
          <input
            type="text"
            [readonly]="true"
            class="form-control"
            class="inp"
            id="groupName"
            placeholder="Name"
            [value]="groupDetail.Name"
          />
        </div>

        <div class="form-group group-detail-field">
          <label class="group-field-label" for="groupDescription">Description</label>
          <input
            type="text"
            [readonly]="true"
            class="form-control"
            class="inp"
            id="groupDescription"
            placeholder="Description"
            [value]="groupDetail.Description"
          />
        </div>

        <div class="form-group group-detail-field">
          <label class="group-field-label" for="createdOn">Created On</label>
          <input
            type="text"
            [readonly]="true"
            class="form-control"
            class="inp"
            id="createdOn"
            placeholder="Created On"
            [value]="groupDetail.Created | custdate"
          />
        </div>

        <div class="form-group group-detail-field">
          <label class="group-field-label" for="lastUpdatedOn">Last Updated On</label>
          <input
            type="text"
            [readonly]="true"
            class="form-control"
            class="inp"
            id="lastUpdatedOn"
            placeholder="Last Updated On"
            [value]="groupDetail.LastUpdated | custdate"
          />
        </div>

        <div class="sla-window-ctrls">
          <app-assign-agents [details]="details"></app-assign-agents>
        </div>
        <!-- "group", "user", this.service(), "GetGroupUsers", false, false, true, !cls.QBRSecurity().validateGrant("ManageAssignments")-->
      </div>
    </div>
  </div>
</div>
